export default {
    data() {
        return {
            packageOptions: [
                { value: '', text: 'Package Type', disabled: true },
                { value: 'single_lp', text: 'Single LP 13x13x1' },
                { value: 'multi_lp', text: 'Multi LP 13x13x1' },
                { value: '45_box', text: '45 Box 8x8x1' },
                { value: 'pizza_box', text: 'Pizza Box 15x14x2' },
                { value: 'small_lp_dbl', text: 'Small LP Dbl 13x13x4' },
                { value: 'international_dbl', text: 'International Dbl 15x15x5' },
                { value: '45_pizza', text: '45 Pizza 9x8x3' },
                { value: 'sm_45_dbl', text: 'Sm 45 Dbl 8x8x4' },
                { value: 'lg_45_dbl', text: 'Lg 45 Dbl 8x8x8' },
                { value: 'md_lp_dbl', text: 'Md LP Dbl 13x13x7' },
                { value: 'lg_lp_dbl', text: 'Lg LP Dbl 13x13x15' },
                { value: 'lg_lp', text: 'Lg LP 12x12x4' },
            ],
        }
    }
}
